export const forceHttps = (urlString: string | undefined): string => {
  const temp = urlString ? urlString.replace(/^http:\/\//i, 'https://') : '';
  return temp && temp.slice(0, 2) === '//' ? temp.replace('//', 'https://') : temp;
};
